export enum Role {
  Direction = 'direction',
  AssistantDirection = 'assistant-direction',
  OfficialRepresentative = 'official-representative',
}
